import React from "react";
import Slider from "react-slick";
import Rcard from "./Testimonialprops";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import classes from "./Testimonials.module.css";

const Testimonial = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 8000,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    rtl: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          speed: 8000,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          cssEase: "linear",
          rtl: true,
        },
      },
    ],
  };

  return (
    <div>
      <div className={classes.rsl6}>
        <div className={classes.rsl2}>
          <Slider {...settings}>
            <div>
              <Rcard text="Medical Career Counselling" />
            </div>

            <div>
              <Rcard text="Application & Form Filling" />
            </div>

            <div>
              <Rcard text="Admission Guidance" />
            </div>

            <div>
              <Rcard text="College & Course Selection" />
            </div>

            <div>
              <Rcard text="NEET Counselling Support" />
            </div>

            <div>
              <Rcard text="Document Verification Assistance" />
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
